import {
  createAsyncThunk,
  createSlice,
  isRejectedWithValue,
} from "@reduxjs/toolkit"
import { update } from "lodash"
import { openNotification } from "src/components/helpers/notification"
import ax from "src/store/config"

const initialState = {
  mailingsContentList: null,
  mailingsContentListLoading: false,
  mailingsInfoList: null,
  mailingsInfoListLoading: false,
  mailingsModalInfo: null,
  mailingsModalInfoLoading: null,
  mailingTypesList: null,
  mailingTypesListLoading: false,
  sendMailingLoading: false,
  cancelLoading: false,
  cancelError: null,
}
export const mailingsContentListAction = createAsyncThunk(
  "mailings/mailingsContentListAction",
  async (payload, { dispatch }) => {
    try {
      dispatch(setMailingsContentListActionLoading(true))
      const { data } = await ax.get("/api/mailing/getMailings", {
        params: payload,
      })
      data && dispatch(setMailingsContentListActionLoading(false))
      return data
    } catch (error) {
      error && dispatch(setMailingsContentListActionLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)
// export const mailingsContentListAction = createAsyncThunk('mailingsContentListAction', async (payload, { dispatch }) => {
//     dispatch(setMailingsContentListActionLoading(true))
//     try {
//         let data;
//         const url = '/api/mailing/getMailings';
//         switch (payload.flag) {
//             case 'get':
//                 ({ data } = await ax.get(url, { params: payload.value }))
//                 data && dispatch(setGymsListLoading(false))
//                 return data

//             case 'delete':
//                 ({ data } = await ax.delete(url, { params: payload.value }))
//                 data && openNotification({
//                     type: 'success',
//                     message: `Рассылка успешно удалена`
//                 })
//                 break;

//             default:
//                 break;
//         }
//     } catch (error) {
//         dispatch(setMailingsContentListActionLoading(false))
//         openNotification({
//             type: 'error',
//             message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
//         })
//         return error
//     }
// })
export const mailingsInfoListAction = createAsyncThunk(
  "mailings/mailingsInfoListAction",
  async (payload, { dispatch }) => {
    try {
      dispatch(setMailingsInfoListActionLoading(true))
      const { data } = await ax.get("/api/mailing/getMailingDetails", {
        params: payload,
      })
      data && dispatch(setMailingsInfoListActionLoading(false))
      return data
    } catch (error) {
      error && dispatch(setMailingsInfoListActionLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)
// export const mailingsInfoListAction = createAsyncThunk('mailingsInfoListAction', async (payload, { dispatch }) => {
//     dispatch(setMailingsContentListActionLoading(true))
//     try {
//         let data;
//         const url = '/api/mailing/getMailingsDetails';
//         switch (payload.flag) {
//             case 'get':
//                 ({ data } = await ax.get(url, { params: payload.value }))
//                 data && dispatch(setGymsListLoading(false))
//                 return data
//             case 'delete':
//                 ({ data } = await ax.delete(url, { params: payload.value }))
//                 data && openNotification({
//                     type: 'success',
//                     message: `Рассылка успешно удалена`
//                 })
//                 break;

//             default:
//                 break;
//         }
//     } catch (error) {
//         dispatch(setMailingsContentListActionLoading(false))
//         openNotification({
//             type: 'error',
//             message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
//         })
//         return error
//     }
// })

export const getMailingContentForUser = createAsyncThunk(
  "mailings/getMailingContentForUser",
  async (payload, { dispatch }) => {
    try {
      dispatch(setMailingContentForUserLoading(true))
      const { data } = await ax.get("/api/mailing/getMailingContentForUser", {
        params: payload,
      })
      data && dispatch(setMailingContentForUserLoading(false))
      return data
    } catch (error) {
      error && dispatch(setMailingContentForUserLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const getMailingTypes = createAsyncThunk(
  "mailings/getMailingTypes",
  async (payload, { dispatch }) => {
    try {
      dispatch(setMailingTypesLoading(true))
      const { data } = await ax.get("/api/mailing/getMailingTypes", {
        params: payload,
      })
      data && dispatch(setMailingTypesLoading(false))
      return data
    } catch (error) {
      error && dispatch(setMailingTypesLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const cancelMailingActions = createAsyncThunk(
  "mailings/cancelMailing",
  async (mailingId, { dispatch }) => {
    try {
      dispatch(setMailingTypesLoading(true))
      const { data } = await ax.delete(`/api/mailing/cancelMailing?mailingId=${mailingId}`)
      data && dispatch(sendMailingLoading(false))
      return data
    } catch (error) {
      error && dispatch(sendMailingLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

export const sendMailing = createAsyncThunk(
  "mailings/sendMailing",
  async (payload, { dispatch }) => {
    try {
      //dispatch(cancelLoading(true))
      const { data } = await ax.post("/api/mailing/setMailings", payload)
      return data
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.status}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
    }
  }
)

const MailingsSlice = createSlice({
  name: "mailings",
  initialState,
  reducers: {
    setMailingsContentListActionLoading: (state, action) => {
      state.mailingsContentListLoading = action.payload
    },
    setMailingsInfoListActionLoading: (state, action) => {
      state.mailingsInfoListLoading = action.payload
    },
    setMailingContentForUserLoading: (state, action) => {
      state.mailingsModalInfoLoading = action.payload
    },
    setMailingTypesLoading: (state, action) => {
      state.mailingTypesListLoading = action.payload
    },
    sendMailingLoading: (state, action) => {
      state.sendMailingLoading = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(mailingsContentListAction.fulfilled, (state, action) => {
      state.mailingsContentList = action.payload
    })
    builder.addCase(mailingsInfoListAction.fulfilled, (state, action) => {
      state.mailingsInfoList = action.payload
      //debugger
    })
    builder.addCase(getMailingContentForUser.fulfilled, (state, action) => {
      state.mailingsModalInfo = action.payload
    })
    builder.addCase(getMailingTypes.fulfilled, (state, action) => {
      state.mailingTypesList = action.payload
    })
    builder.addCase(cancelMailingActions.pending, (state) => {
      ;(state.cancelLoading = true), (state.cancelError = null)
    })
    builder.addCase(cancelMailingActions.fulfilled, (state, action) => {
      state.cancelLoading = false
      if (state.mailingsContentList?.data?.value?.rows) {
        const updatedRows = state.mailingsContentList.data.value.rows.map(
          (item) => (item.id === action.payload.id ? action.payload : item)
        )
        state.mailingsContentList.data.value.rows = updatedRows
      }
    })
    builder.addCase(cancelMailingActions.rejected, (state, action) => {
      ;(state.cancelLoading = false), (state.cancelError = action.payload)
    })
    builder.addCase(sendMailing.pending, (state) => {
      state.sendMailingLoading = true
      state.cancelLoading = true
    })
    builder.addCase(sendMailing.fulfilled, (state, action) => {
      state.sendMailingLoading = false
      state.cancelLoading = false
    })
    builder.addCase(sendMailing.rejected, (state, action) => {
      state.sendMailingLoading = false
      state.cancelLoading = false
    })
  },
})

export const {
  setMailingsContentListActionLoading,
  setMailingsInfoListActionLoading,
  setMailingContentForUserLoading,
  setMailingTypesLoading,
  sendMailingLoading,
} = MailingsSlice.actions

export default MailingsSlice.reducer
